import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteProduct } from "../types";
import { fetchAddNewProduct } from "../apis/addNewProduct";

export const useAddNewProduct = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, QuoteProduct>({
        mutationFn: fetchAddNewProduct,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
